import { compact, get, some } from 'lodash/fp';

import { BEST_SELLERS_PRODUCT_LIST } from '../../ahm-constants/ui';

// @ts-expect-error - Automatic, Please fix when editing this file
const isProductBestSeller = ({ scale, parentProductId, productId, productType }) =>
  some((id) => id === get(`${productType}.${scale}`, BEST_SELLERS_PRODUCT_LIST), compact([parentProductId, productId]));

export default isProductBestSeller;
